__turbopack_context__.v({
  "card": "GXHK8G_card",
  "fullscreen": "GXHK8G_fullscreen",
  "iconContainer": "GXHK8G_iconContainer",
  "paragraph": "GXHK8G_paragraph",
});
